<div>
    <app-header [isSupplierTicketingEnabled]="isSupplierTicketingEnabled"></app-header>
    <div class="page-container">
        <div class="page-content">
            <srm-chatbot *ngIf="isChatbotEnabled" [apiUrl]="chatbotApiUrl" [authTokenPath]="authTokenPath"
                [closeChatOnTransfer]="false" (onTransfer)="onSubmitTicket()"></srm-chatbot>
            <div *ngIf="env != 'PRD'" class="translate-toggle-container">
                <tsl-slide-toggle [checked]="useProdEnv" (change)="switchTranslateEnv($event)">
                    {{ useProdEnv ? "Human" : "Machine" }} Translation
                </tsl-slide-toggle>
            </div>
            <div class="spinner-container" *ngIf="showSpinner">
                <mat-spinner></mat-spinner>
            </div>
            <router-outlet class="outlet"></router-outlet>
        </div>
        <app-footer class="footer" [isSupplierTicketingEnabled]="isSupplierTicketingEnabled"></app-footer>
    </div>
</div>